import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import NotFound from "./NotFound";

/**
 * Écran d'erreur unique pour toutes les routes. Une réponse 404 est présentée
 * comme un lien mort plutôt que comme un plantage de l'application.
 */
const ErrorFallback = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFound />;
  }

  return (
    <div style={{ padding: "2rem", textAlign: "center" }} role="alert">
      <p>
        Une erreur s&apos;est produite. Veuillez actualiser la page. /
        Something went wrong. Please refresh the page.
      </p>
    </div>
  );
};

export default ErrorFallback;
